import {
  FormInput,
  Grid,
  AutocompleteInput,
  DateInput,
  FormGetter,
  FormSetter,
} from '@kirz/mui-admin';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { Box, Typography, Divider, Paper } from '@mui/material';
import React from 'react';

import { FormButton } from 'components/FormButton';

import { FilesField } from '../FilesField';
import { StepWrapper } from '../StepWrapper';

type HouseInfo = {
  adres: string;
  bestemming: string;
  ki: string;
  verhuurdVanDatum?: string;
  verhuurdTotDatum?: string;
  ontvangenBrutoHuur?: string;
};

const bestemmingOptions = [
  'Eigen woonhuis',
  'Verhuurd particulier',
  'Verhuurd zakelijk',
  'Niet verhuurd',
];

export default function Step() {
  return (
    <StepWrapper
      name="Woningen in Buitenland"
      description="Voeg hieronder alle woningen toe die u bezit in het buitenland"
      maxWidth={1000}
    >
      <FormGetter
        names={['foreign_houses']}
        render={({ foreign_houses = [] }) => (
          <Grid container spacing={0}>
            <Grid xs={12} sx={{ mb: 2 }}>
              <FormSetter
                render={(setValue) => (
                  <FormButton
                    variant="outlined"
                    onClick={() => {
                      setValue('foreign_houses', [
                        ...foreign_houses,
                        {
                          adres: '',
                          bestemming: '',
                          ki: '',
                        },
                      ]);
                    }}
                    startIcon={<AddIcon />}
                  >
                    Woning toevoegen
                  </FormButton>
                )}
              />
            </Grid>

            {foreign_houses.map((house: HouseInfo, index: number) => (
              <Grid xs={12} key={index}>
                <Paper
                  elevation={1}
                  sx={{
                    p: 3,
                    mb: 2,
                    width: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.02)',
                  }}
                >
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    mb={2}
                  >
                    <Typography variant="h6" color="primary">
                      Woning {index + 1}
                    </Typography>
                    <FormSetter
                      render={(setValue) => (
                        <FormButton
                          variant="outlined"
                          color="error"
                          size="small"
                          onClick={() => {
                            const newHouses = [...foreign_houses];
                            newHouses.splice(index, 1);
                            setValue('foreign_houses', newHouses);
                          }}
                          startIcon={<DeleteIcon />}
                        >
                          Verwijderen
                        </FormButton>
                      )}
                    />
                  </Box>

                  <Divider sx={{ mb: 3 }} />

                  <Grid container spacing={2}>
                    <AutocompleteInput
                      name={`foreign_houses.${index}.bestemming`}
                      label="Bestemming"
                      options={bestemmingOptions.map((x) => ({
                        text: x,
                        value: x,
                      }))}
                      xs={12}
                      sm={6}
                      required
                    />
                    <FormInput
                      name={`foreign_houses.${index}.adres`}
                      label="Adres"
                      xs={12}
                      sm={6}
                      required
                    />
                    <FormInput
                      name={`foreign_houses.${index}.ki`}
                      label="Kadastraal inkomen"
                      xs={12}
                      sm={6}
                      required
                    />
                    <FormGetter
                      names={[`foreign_houses.${index}.bestemming`]}
                      render={(values) =>
                        values[`foreign_houses.${index}.bestemming`]?.includes(
                          'Verhuurd',
                        ) && (
                          <>
                            <DateInput
                              name={`foreign_houses.${index}.verhuurdVanDatum`}
                              label="Verhuurd van"
                              xs={12}
                              sm={6}
                              required
                            />
                            <DateInput
                              name={`foreign_houses.${index}.verhuurdTotDatum`}
                              label="Verhuurd tot"
                              xs={12}
                              sm={6}
                              required
                            />
                            <FormInput
                              name={`foreign_houses.${index}.ontvangenBrutoHuur`}
                              label="Ontvangen bruto huur"
                              xs={12}
                              sm={6}
                              required
                            />
                          </>
                        )
                      }
                    />

                    <FilesField
                      name={`foreign_houses.${index}.documenten`}
                      title="Upload hier alle beschikbare documenten van deze woning: aankoopakte, aanslagbiljet onroerende voorheffing,..."
                      xs={12}
                      md={12}
                    />
                  </Grid>
                </Paper>
              </Grid>
            ))}
          </Grid>
        )}
      />
    </StepWrapper>
  );
}
